import {
  createEmptySliceBase,
  injectDetailSlice,
  injectTableSlice,
  toReducer
} from '../sliceFactory';

const createPrimaryManagersReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'primaryManagers' });
  const withTable = injectTableSlice({ sliceBase });
  const withDetail = injectDetailSlice({ sliceBase: withTable });
  return toReducer(withDetail);
};

export default createPrimaryManagersReducer;
